import { Skeleton, Table, TableBody, TableContainer } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import AppTableCell from "../../tables/appTableCell"
import AppTableContentRow from "../../tables/appTableContentRow"

const SKELETON_ROWS = 2
const SKELETON_COLS = 9
const rows = Array.from({ length: SKELETON_ROWS }, (_, i) => i)
const cols = Array.from({ length: SKELETON_COLS }, (_, i) => i)

const MonthBucketSkeleton = (): ReactElement => (
    <TableContainer>
        <Table size="medium">
            <TableBody>
                {rows.map((r) => (
                    <AppTableContentRow hover key={`monthSkeleton${r}`}>
                        <AppTableCell sx={{ width: "40px", pl: 0.25 }}>
                            <Skeleton
                                variant="circular"
                                width={40}
                                height={40}
                            />
                        </AppTableCell>
                        {cols.map((c) => (
                            <AppTableCell key={c}>
                                <AppSkeleton />
                            </AppTableCell>
                        ))}
                    </AppTableContentRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
)

export default MonthBucketSkeleton
